/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LeavePolicy } from './LeavePolicy';
import {
    LeavePolicyFromJSON,
    LeavePolicyFromJSONTyped,
    LeavePolicyToJSON,
    LeavePolicyToJSONTyped,
} from './LeavePolicy';

/**
 * 
 * @export
 * @interface ShowLeavePolicyResponse
 */
export interface ShowLeavePolicyResponse {
    /**
     * 
     * @type {LeavePolicy}
     * @memberof ShowLeavePolicyResponse
     */
    data: LeavePolicy;
}

/**
 * Check if a given object implements the ShowLeavePolicyResponse interface.
 */
export function instanceOfShowLeavePolicyResponse(value: object): value is ShowLeavePolicyResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ShowLeavePolicyResponseFromJSON(json: any): ShowLeavePolicyResponse {
    return ShowLeavePolicyResponseFromJSONTyped(json, false);
}

export function ShowLeavePolicyResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShowLeavePolicyResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': LeavePolicyFromJSON(json['data']),
    };
}

  export function ShowLeavePolicyResponseToJSON(json: any): ShowLeavePolicyResponse {
      return ShowLeavePolicyResponseToJSONTyped(json, false);
  }

  export function ShowLeavePolicyResponseToJSONTyped(value?: ShowLeavePolicyResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': LeavePolicyToJSON(value['data']),
    };
}

